import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StaticView from './index';
import StaticDisqusView from './StaticDisqusView';

class StaticWrap extends Component {
  render() {
    const { newCommentSystem, pageCommentsBoardId, ...rest } = this.props;
    const StaticPage = (pageCommentsBoardId && pageCommentsBoardId.length > 0) ? StaticView : StaticDisqusView;
    return (<StaticPage {...rest} />);
  }
}

StaticWrap.propTypes = {
  newCommentSystem: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    newCommentSystem: state.currentItem.data.newCommentSystem,
    pageCommentsBoardId: state.globalConfig.pageCommentsBoardId,
  };
};
export default connect(mapStateToProps)(StaticWrap);
